export enum GuestRelationForms {
  UpdateRelations = 'UpdateRelations',
}
